import { gql } from '@apollo/client';

/** Mirrors `AssetCorrelationType` in public-api `assetCorrelations.graphql`. */
export const ASSET_CORRELATION_TYPE = Object.freeze({
  UNSPECIFIED: 'UNSPECIFIED',
  VULNERABILITY: 'VULNERABILITY',
  COMPONENT: 'COMPONENT',
  CERTIFICATE: 'CERTIFICATE',
  PUBLIC_KEY: 'PUBLIC_KEY',
  PRIVATE_KEY: 'PRIVATE_KEY',
  SECRET: 'SECRET',
  MISCONFIG: 'MISCONFIG',
  BINARY: 'BINARY',
  USER: 'USER',
  HASH: 'HASH'
});

export const QL_LIST_ASSET_CORRELATIONS = gql`
  query listAssetCorrelationsQuery($args: ListAssetCorrelationsInput!) {
    listAssetCorrelations(args: $args) {
      edges {
        cursor
        node {
          assetId
          assetName
          artifact
          location
          updatedAt
          risk {
            score
            rawScore
            category
          }
        }
      }
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;
